import Layout from "@/layout/desktop/Layout.vue"
import { preRetrofit } from "./mobile"
const authRoutes = [
  { path: "", redirect: "/login" },
  {
    path: "/login",
    name: "desktopLogin",
    component: () => import("../views/desktop/auth/Login.vue")
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/desktop/auth/Register.vue")
  },
  {
    path: "/password",
    name: "ResetPassword",
    component: () => import("../views/desktop/auth/Password.vue")
  },
  {
    path: "/loading",
    name: "loadData",
    component: () => import("../views/mobile/auth/loading.vue")
  }
]

export const desktopRoutes = [
  ...authRoutes,
  { path: "/home", component: () => import("@/views/mobile/home/Home.vue") },
  { path: "/dispatch", component: () => import("@/views/mobile/dispatch/Dispatching.vue") },
  { path: "/admin", component: () => import("@/views/mobile/admin/Admin.vue") },
  { path: "/account", component: () => import("@/views/mobile/admin/account/Account.vue") },
  { path: "/my", component: () => import("@/views/mobile/my/My.vue") },
  { path: "/about", component: () => import("@/views/mobile/my/about/About.vue") },

  {
    path: "/project",
    component: () => import("@/views/mobile/project/Project.vue"),
    children: [
      {
        path: "postRetrofit",
        component: () => import("@/views/mobile/project/postRetrofit/Post.vue")
      },
      {
        path: "postOptionDetails",
        component: () => import("@/views/mobile/project/postRetrofit/PostOptionDetails.vue")
      }
    ]
  },
  { path: "/systemConfig", component: () => import("@/views/mobile/project/projectSubPage/systemConfigPage/SystemConfig.vue") },
  { path: "/energyConsumptionAnalysis", component: () => import("@/views/mobile/project/projectSubPage/energyConsumptionAnalysisPage/EnergyConsumptionAnalysis.vue") },
  { path: "/oduInstallation", component: () => import("@/views/mobile/project/projectSubPage/oduInstallationPage/OduInstallation.vue") },
  { path: "/iduInstallation", component: () => import("@/views/mobile/project/projectSubPage/iduInstallationPage/IduInstallation.vue") },

  { path: "/importSysFromIoT", component: () => import("@/views/mobile/project/projectSubPage/ImportSysFromIoT.vue") }
]



// WEBPACK FOOTER //
// ./src/router/desktop.js